export enum CurrencyLocation {
  PREPEND = 'prepend',
  APPEND = 'append'
}

export enum DecimalSeparator {
  COMMA = ',',
  DOT = '.'
}

export enum RoundingMethod {
  ROUND = 'round',
  TRUNCATE = 'truncate'
}

export enum ThousandsSeparator {
  NONE = '',
  SPACE = ' ',
  COMMA = ',',
  DOT = '.'
}
